// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__r3-QF{
    display: flex;
    justify-content: center;
    padding: 1rem;
}

.styles_header__qmn-H{
    color: #18316e;
    margin-bottom: 1rem;
    text-align: center;
}

.styles_containerBtn__Mjckf{
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
}

.styles_btnBack__QdUdD{
    border-color: #18316e !important;
    color: #18316e !important;
    &:hover{
        border-color: #18316e !important;
    }
}

.styles_btnForward__B\\+Iby{
    background-color: #18316e !important;
    color: white !important;
    &:hover{
        background-color: #1a3b70 !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/CadastroClienteSimples/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB;QACI,oCAAoC;IACxC;AACJ","sourcesContent":[".container{\n    display: flex;\n    justify-content: center;\n    padding: 1rem;\n}\n\n.header{\n    color: #18316e;\n    margin-bottom: 1rem;\n    text-align: center;\n}\n\n.containerBtn{\n    display: flex;\n    justify-content: space-between;\n    margin-top: 1rem;\n}\n\n.btnBack{\n    border-color: #18316e !important;\n    color: #18316e !important;\n    &:hover{\n        border-color: #18316e !important;\n    }\n}\n\n.btnForward{\n    background-color: #18316e !important;\n    color: white !important;\n    &:hover{\n        background-color: #1a3b70 !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__r3-QF`,
	"header": `styles_header__qmn-H`,
	"containerBtn": `styles_containerBtn__Mjckf`,
	"btnBack": `styles_btnBack__QdUdD`,
	"btnForward": `styles_btnForward__B+Iby`
};
export default ___CSS_LOADER_EXPORT___;
